import { render, staticRenderFns } from "./ContextMenuColumn.vue?vue&type=template&id=1a42b912&"
import script from "./ContextMenuColumn.vue?vue&type=script&lang=js&"
export * from "./ContextMenuColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports